export function MicIcon({ size = 24 }: { size?: number }) {
  return (
    <svg viewBox="0 0 24 24" fill="white" width={size} height={size}>
      <path d="M12 1a3.5 3.5 0 0 0-3.5 3.5v7a3.5 3.5 0 0 0 7 0v-7A3.5 3.5 0 0 0 12 1z" />
      <path d="M18.5 11.5A6.5 6.5 0 0 1 5.5 11.5H4a8 8 0 0 0 7.25 7.97V22h1.5v-2.53A8 8 0 0 0 20 11.5h-1.5z" />
    </svg>
  );
}
